import { useAuthSelector } from 'app/data/auth';
import templateQueryKeys from 'app/hooks/queries/template/templateQueryKeys';
import { sdk } from 'app/sdk';
import { QueryKey, useQuery, UseQueryOptions } from 'react-query';
import { PhoneNumbersPageResponse } from 'types/phoneNumber';
import { TemplatesPageResponse } from 'types/template';

interface QueryParams {
  skip?: number;
  take?: number;
  orderBy?: any;
  filters?: any;
  options?: Omit<
    UseQueryOptions<
      TemplatesPageResponse,
      Error,
      TemplatesPageResponse,
      QueryKey
    >,
    'queryKey' | 'queryFn'
  >;
}

export const useListTemplatesQuery = ({
  skip = 0,
  take = 10000,
  orderBy = [['name', 'asc']],
  filters = {},
  options,
}: QueryParams) => {
  // returns list of templates
  // - just get ALL templates+relations
  // - TODO v2: can be filtered/etc
  const authState = useAuthSelector();
  const queryKey = templateQueryKeys.list(skip, take, orderBy, filters);

  const query = useQuery<TemplatesPageResponse, Error>(
    queryKey,
    () =>
      sdk.template.query.templates(
        {
          skip,
          take,
          orderBy,
          filters,
        },
        { authToken: authState.auth_token },
      ),
    {
      // enabled: authState?.auth_token_decoded?.owner_id ? true : false,

      // prevents pagination from looking like a hard load;
      //  - keeps previous data displayed until new data arrives
      keepPreviousData: true,
      ...options,
    },
  );

  return {
    ...query,
    queryKey,
  };
};

export default useListTemplatesQuery;
